import {
  DetailedHTMLProps,
  FC,
  HTMLAttributes,
  ReactNode,
  useCallback,
  useRef,
} from 'react'

import {
  SegmentedControlProps as MantineSegmentedControlProps,
  clsx,
} from '@mantine/core'

import {
  StyledSegmentedControl,
  StyledSegmentedControlItem,
  StyledSegmentedControlItemIcon,
} from './SegmentedControl.styled'

export type SegmentedControlItem = Omit<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'onClick'
> & {
  key: string
  icon?: ReactNode
  label?: ReactNode
}
export type SegmentedControlProps = Omit<
  MantineSegmentedControlProps,
  'data'
> & {
  items?: SegmentedControlItem[]
}
export const SegmentedControl: FC<SegmentedControlProps> = (props) => {
  const {
    items,
    size = 'lg',
    radius = 8,
    className,
    style,
    onChange: onChangeProps,
    ...restProps
  } = props
  const $container = useRef<HTMLDivElement>(null)

  const onChange = useCallback(
    (value: string) => {
      onChangeProps?.(value)
      setTimeout(() => {
        const $activeElement = $container.current?.querySelector(
          '.mantine-SegmentedControl-controlActive',
        )
        if ($activeElement) {
          $activeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          })
        }
      }, 0)
    },
    [onChangeProps],
  )

  if (!items?.length) {
    return null
  }

  return (
    <StyledSegmentedControl
      ref={$container}
      size={size}
      radius={radius}
      data={items.map((item) => {
        const { key, icon, label, className, style, ...restPropsItem } = item

        return {
          value: key,
          label: (
            <StyledSegmentedControlItem
              style={style}
              className={clsx(
                className,
                'segmentedControlItem',
                `segmentControlItem-${key}`,
              )}
              {...restPropsItem}
            >
              {!!icon && (
                <StyledSegmentedControlItemIcon className="segmentedControlItemIcon">
                  {icon}
                </StyledSegmentedControlItemIcon>
              )}
              <span className="segmentedControlItemLabel">{label}</span>
            </StyledSegmentedControlItem>
          ),
        }
      })}
      style={style}
      className={clsx(className, 'segmentedControl')}
      onChange={onChange}
      {...restProps}
    />
  )
}
